<template>
  <div class="form-field-wrapper">
    <van-field class="kw-field" v-bind="$attrs" :error-message="''" @end-validate="handleValidate">
      <template v-slot:error-message="{ message }">
        <!-- <div class="text-red-500 text-sm mt-1 hidden">{{ message }}</div> -->
      </template>
      <template v-for="(_, name) in $slots" v-slot:[name]="slotData">
        <slot :name="name" v-bind="slotData || {}" />
      </template>
    </van-field>
    <div v-if="error" class="text-red-500 text-xs mt-1">
      {{ error }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

const error = ref('')

const handleValidate = ({ status, message }: { status: string; message: string }) => {
  error.value = status === 'failed' ? message : ''
}
</script>
